<template>
  <div class="userModule">
      <div class="userMenu">
        <div class="title">个人中心</div>
            <ul class="account-nav">
                <li v-for="(item,i) in nav" :key='i' :class="{current:item.name===title}"
                    @click="tab(item)">{{item.name}}</li>
            </ul>
      </div>
      <div class="userContent">
        <router-view></router-view>
      </div>
      <div class="clear">&nbsp;</div>
  </div>
</template>
<style>
@import '../../styles/user.css';
</style>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        title: '我的订单',
        nav: [
          {name: '我的订单', path: 'orderList'},
        //   {name: '账户资料', path: 'profile'},
          {name: '收货地址', path: 'addressList'},
          {name: '发票模板', path: 'invoiceList'},
          {name: '修改密码', path: 'updatePassword'},
          {name: '商品收藏', path: 'collectProductList'},
          {name: '店铺收藏', path: 'collectSupplierList'},
        ],
        editAvatar: true
      }
    },
    computed: {
      ...mapState(['profile'])
    },
    methods: {
      tab (e) {
        this.$router.push({path: '/user/' + e.path})
      }
    },
    created () {
      let path = this.$route.path.split('/')[2]
      this.nav.forEach(item => {
        if (item.path === path) {
          this.title = item.name
        }
      })
    },
    watch: {
      $route (to) {
        let path = to.path.split('/')[2]
        this.nav.forEach(item => {
          if (item.path === path) {
            this.title = item.name
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1541f232